/**
 * 主页
 */
import React from 'react';
import styles from './index.module.scss';
import PropTypes from 'prop-types';
import NavCard from './components/NavCard';
import NavPosition from './components/NavPosition';
import TopNav from './components/TopNav';
import { Route, Switch } from 'react-router-dom';
import { connect } from 'react-redux';
import * as AllActions from '@/reducers/home/actions';
import { Avatar, message } from 'antd';
import { setLocalStorage, getLocalStorage, removeSessionStorage } from '@/assets/js/storage';
import http from '@/assets/api/http';
// import menuList from '@/routes/companyMenu';
import { isOC } from '@/assets/js/authType';

class Home extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isToggleCard: false, // 用于区别当前用户点击的是一级导航还是二级导航，true表示点击一级导航
            stretchOpen: this.props.stretchOpen, // 导航栏的伸展状态
            emplName: '', // 用户名
            avatar: '', // 头像
            headNavWidth: null, // 顶部TopNav组件宽度
            updateRandom: 0
        };
    }

    componentDidMount() {
        const userInfo = getLocalStorage('auth') ? JSON.parse(getLocalStorage('auth')).userInfo : null;
        if (userInfo == null) {
            this.props.history.push({ pathname: '/' });
            setTimeout(() => { location.reload(); }, 500);
        } else {
            const { emplName, avatar } = userInfo;
            this.setState({ emplName, avatar });
            this.props.getMenuList();
        }

        //监听窗口变化，动态获取顶部TopNav组件宽度
        this._renderNavWidth();
        window.addEventListener('resize', () => { this._renderNavWidth(); });

        const { accountType } = userInfo;
        const fromLogin = getLocalStorage('fromLogin');
        if (fromLogin == '1') {
            if (accountType == 'ADMIN') {
                setTimeout(() => { this.props.history.push({ pathname: '/home/operation/company' }); }, 500); // 总控后台首页
            } else if (accountType == 'COMPANY') {
                setTimeout(() => { this.props.history.push({ pathname: '/home/user/agent' }); }, 500); // 运营后台首页
            }
            setLocalStorage('fromLogin', '');
        }
    }

    componentWillUnmount() {
        window.removeEventListener('resize', () => { this._renderNavWidth(); }); //卸载
    }

    // 用户点击一级导航回调函数
    _firstCardHandle = (path) => {
        this.props.setFirstCardPath(path);
        this.props.setSecondCardPath('');
        this.props.setThirdCardPath('');
        this.jump(path);
    }

    // 用户点击二级导航回调函数
    _secondCardHandle = (path, rItem) => {
        this.props.setSecondCardPath(path);
        this.setState({ isToggleCard: true, stretchOpen: true });
        if (!(rItem.childrenNode && Array.isArray(rItem.childrenNode) && rItem.childrenNode.length > 0)) {
            this.jump(path);
        }
    }

    // 用户点击三级导航回调函数
    _thirdCardHandle = (path) => {
        this.props.setThirdCardPath(path);
        this.setState({ isToggleCard: false });
        this.jump(path);
    }

    // 清空页面缓存，与KeepAlive配合使用
    jump = (path) => {
        const href = window.location.href;
        const list = href.split('/');
        let cacheName = '';
        if (list[list.length - 1] == '') {
            cacheName = list[list.length - 3] + '/' + list[list.length - 2];
        } else {
            cacheName = list[list.length - 2] + '/' + list[list.length - 1];
        }
        removeSessionStorage(cacheName);
        this.props.history.push({
            pathname: path
        });
    }

    // 渲染头部导航栏
    _renderTop = (routes) => {
        let navlist = [];
        for (let i = 0; i < routes.length; i++) {
            if (routes[i].path != '/' && routes[i].path != '/setting') {
                navlist.push(routes[i]);
            }
        }
        return (
            <TopNav
                navlist={navlist}
                firstCardHandle={this._firstCardHandle}
                firstCardPath={this.props.firstCardPath}
                match={this.props.match}
            />
        );
    }

    // 渲染手风琴导航组件
    _renderNav = (routes) => {
        const { firstCardPath, match } = this.props;
        // 左侧栏显示为topnav中对应的活动导航
        let activeNode = null;
        for (let i = 0; i < routes.length; i++) {
            if (routes[i].path != '/' && routes[i].path != '/setting' && firstCardPath == (match.path + routes[i].path)) {
                activeNode = routes[i];
                break;
            }
        }
        const childremNode = (activeNode && activeNode.childrenNode) ? activeNode.childrenNode : [];
        return (
            <div className={styles.slide}>
                <div className={styles.nav} style={this.state.stretchOpen ? { width: '220px', backgroundColor: '#FFFFFF' } : { width: '0px' }}>
                    {
                        childremNode.map((item) => {
                            if (item.show && item.show == 'none') {
                                return null;
                            }
                            return this._renderNavCard(item);
                        })
                    }
                </div>
                <div className={styles.sbox}>
                    <div className={styles.sitem}><span className={styles.sicon}></span></div>
                </div>
            </div>
        );
    }

    // 渲染手风琴导航组件各个项
    _renderNavCard = (rItem) => {
        return (
            <NavCard
                key={rItem.path}
                rItem={rItem}
                isToggleCard={this.state.isToggleCard}
                match={this.props.match}
                history={this.props.history}
                firstCardPath={this.props.firstCardPath}
                secondCardHandle={this._secondCardHandle}
                secondCardPath={this.props.secondCardPath}
                thirdCardHandle={this._thirdCardHandle}
                thirdCardPath={this.props.thirdCardPath}
            />
        );
    }

    // 渲染路由页面，随着导航点击响应页面变化
    _renderRoute = (routes) => {
        let routeList = [];
        routes.forEach((rItem) => {
            let route = {};
            if (rItem.component) {
                route.key = this.props.match.path + rItem.path;
                route.path = this.props.match.path + rItem.path;
                route.component = rItem.component;
                routeList.push(route);
            }
            if (rItem.childrenNode) {
                rItem.childrenNode.forEach((rItemChild) => {
                    if (rItemChild.childrenNode && Array.isArray(rItemChild.childrenNode) && rItemChild.childrenNode.length > 0) {
                        rItemChild.childrenNode.forEach((rItemChild2) => {
                            let cr = {};
                            cr.key = this.props.match.path + rItem.path + rItemChild.path + rItemChild2.path;
                            cr.path = this.props.match.path + rItem.path + rItemChild.path + rItemChild2.path;
                            cr.component = rItemChild2.component;
                            routeList.push(cr);
                        });
                    } else {
                        let cr = {};
                        cr.key = this.props.match.path + rItem.path + rItemChild.path;
                        cr.path = this.props.match.path + rItem.path + rItemChild.path;
                        cr.component = rItemChild.component;
                        routeList.push(cr);
                    }
                });
            }
        });
        return (
            routeList.map((route) => {
                return (
                    <Route
                        exact
                        key={route.key}
                        path={route.path}
                        component={
                            route.component
                        }
                    />
                );
            })
        );
    }

    // // 界面伸缩，当该函数触发时导航栏收缩至只剩图标
    // _drawerHandle = () => {
    //     this.props.setStretchOpen(!this.state.stretchOpen);
    //     this.setState({ stretchOpen: !this.state.stretchOpen });
    // }

    // 总控菜单（权限管理二期开发，暂时在前端写死）
    _getAdminRoutes = (routes) => {
        let adminRoutes = this._deleteCompanyMenu(routes);
        return adminRoutes;
    }

    // 当为平台账号，总菜单中递归删除仅在运营中心才显示的菜单
    _deleteCompanyMenu = (menulistValue) => {
        const menulist = this._deepCopy(menulistValue);
        const result = [];
        for (let i = 0; i < menulist.length; i++) {
            if (!this._hasCompanyMenu(menulist[i].path)) {
                let childrenNode = menulist[i].childrenNode;
                if (Array.isArray(childrenNode) && childrenNode.length > 0) {
                    menulist[i].childrenNode = this._deleteCompanyMenu(childrenNode);
                }
                result.push(menulist[i]);
            }
        }
        return result;
    }

    // 数组对象类型深度拷贝算法
    _deepCopy(obj) {
        if (typeof obj !== 'object') {
            return obj;
        }
        var res = Array.isArray(obj) ? [] : {};
        for (let i in obj) {
            if (i == 'component') {
                res[i] = obj[i];
            } else {
                res[i] = this._deepCopy(obj[i]);
            }
        }
        return res;
    }

    // 是否有仅在运营中心才显示的菜单
    _hasCompanyMenu = (path) => {
        const deleteMenu = ['/companyhelp', '/baseinfo', '/qualificationinfo', '/areainfo', '/financialinfo'];
        let result = false;
        for (let i = 0; i < deleteMenu.length; i++) {
            if (deleteMenu[i] == path) {
                result = true;
                break;
            }
        }
        return result;
    }

    // 筛选菜单权限(由于权限按钮没做，menuList暂设定为运营后台菜单)
    _getMenuRoutes = (routes, menuList) => {
        const auth = getLocalStorage('auth') ? JSON.parse(getLocalStorage('auth')) : null;
        // 如果页面打开时没有查到用户信息，则返回登录页面
        if (auth == null) {
            this.props.history.push({ pathname: '/' });
            setTimeout(() => { location.reload(); }, 500);
            return;
        }

        // const { accountType } = auth.userInfo;
        // // 超级管理员返回全部菜单
        // if (accountType == 'ADMIN') {
        //     return this._getAdminRoutes(routes); // 移除运营中心相关菜单并返回剩余菜单，不再往下执行
        // }

        let mRoutes = routes.map((rItem) => {
            if (rItem.path == '/' || rItem.path == '/setting') {
                return rItem;
            } else {
                const pathUrl = rItem.path.substring(1, rItem.path.length);
                let boolean = false;
                let menuItem = {};
                for (let i = 0; i < menuList.length; i++) {
                    if (pathUrl == menuList[i].menuUrl) {
                        menuItem = menuList[i];
                        boolean = true;
                        break;
                    }
                }
                let newRoute = {};
                if (boolean) {
                    newRoute = { ...rItem, childrenNode: [] };
                    const childrenNode = rItem.childrenNode;
                    const menuItemChildrens = menuItem.children;
                    for (let m = 0; m < childrenNode.length; m++) {
                        const childrenNodePath = childrenNode[m].path;
                        if (menuItemChildrens && menuItemChildrens.length == 0) {
                            newRoute.childrenNode.push(childrenNode[m]);
                            continue;
                        }
                        for (let n = 0; n < menuItemChildrens.length; n++) {
                            const menuUrl = menuItemChildrens[n].menuUrl;
                            if (childrenNodePath == menuUrl || childrenNodePath == ('/' + menuUrl) || (childrenNodePath.indexOf(menuUrl) > -1 && childrenNode[m].show == 'none')) {
                                const thirdchildrenNode = childrenNode[m].childrenNode || [];
                                const thirdmenuchildren = menuItemChildrens[n].children;
                                let thirdShowList = [];
                                if (Array.isArray(thirdchildrenNode) && thirdchildrenNode.length > 0) {
                                    for (let k = 0; k < thirdchildrenNode.length; k++) {
                                        const thirdchildrenpath = thirdchildrenNode[k].path;
                                        for (let l = 0; l < thirdmenuchildren.length; l++) {
                                            const thirdmenupath = thirdmenuchildren[l].menuUrl;
                                            if (thirdchildrenpath == thirdmenupath || thirdchildrenpath == ('/' + thirdmenupath) || (thirdchildrenpath.indexOf(thirdmenupath) > -1 && thirdchildrenNode[k].show == 'none')) {
                                                thirdShowList.push(thirdchildrenNode[k]);
                                                break;
                                            }
                                        }
                                    }
                                    childrenNode[m].childrenNode = thirdShowList;
                                    newRoute.childrenNode.push(childrenNode[m]);
                                } else {
                                    newRoute.childrenNode.push(childrenNode[m]);
                                }
                                break;
                            }
                        }
                    }
                    return newRoute;
                }
            }
        });

        mRoutes = mRoutes.filter((item) => {
            if (item != undefined) {
                return true;
            } else {
                return false;
            }
        });

        // 生产环境下，只能返回 mRoutes
        if (process.env.NODE_ENV === 'production') {
            return mRoutes; // 这段代码不要动
        } else {
            return mRoutes;
        }
    }

    // 退出
    _logout = () => {
        http('/?cmd=com.xqxc.api.pig.mis.biz.account.AdminLoginService.logout', {}, 'POST').then((response) => {
            message.success('退出成功');
            this.props.history.push({ pathname: '/' });
        }).catch((e) => {
            if (e && e.message) message.error(e.message);
        });
    }

    // 打开个人设置
    _settingHandle = () => {
        this.props.setFirstCardPath('/home/setting');
        this.props.setSecondCardPath('');
        this.props.setThirdCardPath('');
        this.jump('/home/setting');
        setTimeout(() => { this.setState({ updateRandom: Math.random() }); }, 500);
    }

    _saveButtonPermission = (menuList) => {
        const premission = this._getButtonUrlForChildren(menuList);
        setLocalStorage('btnPremission', premission);
    }

    _getButtonUrlForChildren = (treeData) => {
        let childrenEventKeys = [];
        for (let i = 0; i < treeData.length; i++) {
            if (treeData[i].menuType == 'BUTTON' || treeData[i].menuType == 'TAB_PAGE') {
                childrenEventKeys.push({ url: treeData[i].menuUrl, type: treeData[i].readType });
            }
            if (treeData[i].children && treeData[i].children.length > 0) {
                const array = this._getButtonUrlForChildren(treeData[i].children);
                childrenEventKeys = Array.from(new Set([...childrenEventKeys, ...array]));
            }
        }
        return childrenEventKeys;
    }

    //动态获取顶部TopNav组件宽度（左右侧边栏宽度固定）
    _renderNavWidth = () => {
        if (!this.tipsiconRef) return;
        let { width } = this.tipsiconRef.getBoundingClientRect();
        let headNavWidth = width > 190 ? width : 190;
        this.setState({ headNavWidth });
    }
    render() {
        const { routes, history, match, location, menuList } = this.props;
        const { emplName, avatar, headNavWidth } = this.state;
        const mRoutes = this._getMenuRoutes(routes, menuList);
        const auth = JSON.parse(getLocalStorage('auth'));
        const { companyName } = auth.userInfo;
        this._saveButtonPermission(menuList); // 获取按钮权限

        return (
            <div className={styles.container}>
                <div className={styles.header}>
                    <div className={styles.logo}>
                        {isOC() ? <img src={require('@/assets/image/logo_oc_neiye.png').default} /> : <img src={require('@/assets/image/logo_neiye.png').default} />}
                    </div>
                    <div
                        ref={(tipsiconRef) => this.tipsiconRef = tipsiconRef}
                        className={styles.tipsicon}
                        style={{ width: headNavWidth }}
                    >
                        {this._renderTop(mRoutes)}
                    </div>
                    <div className={styles.help}>
                        <div className={styles.other}>
                            <div className={styles.companyName}>
                                {companyName}
                            </div>
                            {/* <div className={styles.alert}>
                                    <img className={styles.alert_img} src={require('@/assets/image/xiaoxi.png').default} />
                                </div> */}
                            <div className={styles.userinfo} onClick={this._settingHandle}>
                                <Avatar style={{ minWidth: '40px', minHeight: '40px', backgroundColor: '#00284D' }} size={40} icon="U" src={avatar} />
                                <p className={styles.userinfo_name}>{emplName}</p>
                            </div>
                        </div>
                        <div className={styles.logout} onClick={this._logout}>
                            <img className={styles.icon} src={require('@/assets/image/logout.png').default} />
                            <span>退出系统</span>
                        </div>
                    </div>
                </div>
                <div className={styles.body}>
                    {this._renderNav(mRoutes)}
                    <div className={styles.content} id='home_content'>
                        {/* <div className={styles.sbox}>
                                <div className={styles.sitem} onClick={this._drawerHandle}><span className={stretchOpen ? styles.letfsicon : styles.rightsicon}></span></div>
                            </div> */}
                        <div className={styles.rbox}>
                            <NavPosition history={history} match={match} location={location} menuList={menuList} updatePage={() => { this.setState({ updateRandom: Math.random() }); }} />
                            <div className={styles.routerstyle}>
                                <Switch>
                                    {this._renderRoute(mRoutes)}
                                </Switch>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    firstCardPath: state.home.firstCardPath, // 活动的一级导航路径
    secondCardPath: state.home.secondCardPath, // 活动的二级导航路径
    thirdCardPath: state.home.thirdCardPath, // 活动的三级导航路径
    stretchOpen: state.home.stretchOpen, // 导航栏的伸展状态
    menuList: state.home.getMenuList,
});

Home.propTypes = {
    location: PropTypes.object, // 路由history对象
    history: PropTypes.object, // 路由history对象
    match: PropTypes.object, // 路由match对象
    routes: PropTypes.array, // 路由
    stretchOpen: PropTypes.bool, // 导航栏的伸展状态
    setStretchOpen: PropTypes.func, // 存储导航栏的伸展状态的函数
    getMenuList: PropTypes.func, // 获取该用户权限内相关菜单列表
    menuList: PropTypes.array, // 展示的菜单列表
    firstCardPath: PropTypes.string, // 活动的一级导航路径 
    setFirstCardPath: PropTypes.func, // 存储一级导航路径的函数
    secondCardPath: PropTypes.string, // 活动的二级导航路径
    setSecondCardPath: PropTypes.func, // 存储二级导航路径的函数
    thirdCardPath: PropTypes.string, // 活动的三级导航路径
    setThirdCardPath: PropTypes.func, // 存储三级导航路径的函数
    setBreadcrumbPaths: PropTypes.func,
};

export default connect(mapStateToProps, AllActions)(Home);